module.exports = { id: "led", url: "/build/app/img/symbols.svg#led", viewBox: "", toString: function() { return this.url; } };